import React from "react";
import { Box, Popper, useTheme, alpha } from "@mui/material";

interface MapTooltipProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  projectCount: number;
  levelLabel: string;
}

/**
 * Custom tooltip component for the geographic distribution map
 * Displays project count and level with a dark blue background and pointer arrow
 */
export const MapTooltip: React.FC<MapTooltipProps> = ({
  open,
  anchorEl,
  projectCount,
  levelLabel,
}) => {
  const theme = useTheme();

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="top"
      modifiers={[
        {
          name: "offset",
          options: {
            offset: [0, 10],
          },
        },
        {
          name: "preventOverflow",
          options: {
            padding: 8,
          },
        },
      ]}
      sx={{
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <Box
        sx={{
          position: "relative",
          backgroundColor: theme.palette.darkBlue,
          color: theme.palette.common.white,
          padding: "10px 16px",
          borderRadius: "12px",
          boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.25)}`,
          minWidth: "120px",
        }}
      >
        <Box
          sx={{
            fontSize: "11px",
            fontWeight: 500,
            color: alpha(theme.palette.common.white, 0.7),
            marginBottom: "2px",
            textTransform: "capitalize",
          }}
        >
          Projects
        </Box>
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: 1.3,
            whiteSpace: "nowrap",
          }}
        >
          {projectCount} - {levelLabel}
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: "-10px",
            left: "50%",
            transform: "translateX(-50%)",
            width: 0,
            height: 0,
            borderLeft: "10px solid transparent",
            borderRight: "10px solid transparent",
            borderTop: `10px solid ${theme.palette.darkBlue}`,
          }}
        />
      </Box>
    </Popper>
  );
};
